export const doc = document;
export const root = document.documentElement;
export const RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
export const $ = (s, c) => (c || doc).querySelector(s);
export const $$ = (s, c) => Array.prototype.slice.call((c || doc).querySelectorAll(s));
export const fmt = (n) => Math.round(n).toLocaleString("en-US");

// Reads a CSS custom property from :root (used by canvas code).
export const cssVar = (name, fallback = "") => {
  const v = getComputedStyle(root).getPropertyValue(name).trim();
  return v || fallback;
};

// Converts any CSS color to "r,g,b" so canvas can build rgba() strings.
export const rgbOf = (color) => {
  const c = doc.createElement("canvas").getContext("2d");
  c.fillStyle = "#000";
  c.fillStyle = color;
  const hex = c.fillStyle;
  if (hex[0] === "#") {
    const n = parseInt(hex.slice(1), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  const m = hex.match(/[\d.]+/g) || [0, 0, 0];
  return [+m[0], +m[1], +m[2]];
};
